

export const unique = (arr, results = []) => arr.filter((element) => {
  const isDuplicate = results.includes(element.id)

  if (!isDuplicate) {
    results.push(element.id)
    return true
  }
  return false
})

export const findCredentialById = (arr, id) => arr.find((credential) => credential.id === id.toString())



// WEBPACK FOOTER //
// ./src/store/modules/credential/helpers.js